<template lang="pug">
Page.promo
    .promo__top(
        slot="header"
    )
        h1.promo__title
            | Акции

        .promo__subheader
            SvInput.promo__search(
                v-model="search"
                placeholder="Введите название акции"
                color="gray"
                size="large"
            )

            SvButton.promo__add(
                view="big"
                text="Добавить"
                :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                @click="transfer('new')"
            )

    SvTable.promo__table(
        :headers="headers"
        :body="list"
        @transfer="(el) => transfer(el.id)"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
  name: 'Promo',

  data() {
    return {
      headers: [
        {
          title: 'Название',
          path: 'title',
          width: '25%',
        },
        {
          title: 'Жилой комплекс',
          path: 'residential',
          width: '30%',
        },
        {
          title: 'Дата изменения',
          path: 'updated_at',
          width: '25%',
        },
        {
          title: 'Аквтивность',
          path: 'is_active',
          width: '20%',
        },
      ],
    };
  },

  beforeMount() {
    this.$store.dispatch('promo/getList');
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTable,
  },

  computed: {
    ...mapGetters({
      list: 'promo/getList',
    }),

    search: {
      get() {
        return this.$store.state.promo.search;
      },

      set(search) {
        this.$store.commit('promo/setSearch', search);
      },
    },
  },

  methods: {
    transfer(id) {
      this.$router.push({
        name: 'promo-edit',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.promo__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.promo__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.promo__search {
    width: 47%;
    min-width: 280px;
}

.promo__table {
    margin-top: 30px;
}
</style>
